export const validMobilePhone = new RegExp(/^0(6|7)[0-9]{8}$/)